module.exports = __webpack_public_path__ + "static/ncsc-logo-83c9b385ec79d346c7accedb19a876b2.png";